import React from 'react';
import './AddNote.css';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCheckbox} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';

/**
 * La vue qui permet d'ajouter des médias
 * @param {*} props props
 * @return {JSX}
 */
function AddNoteView(props) {
  return (
    <div className="banktable-container">

      <MDBContainer fluid >
        <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
          <MDBCol col="12">
            <MDBCard className="bg-dark text-white my-2 mx-auto align-items-center"
              style={{borderRadius: '1rem', maxWidth: '800px'}}>
              <h2 className="fw-bold mb-2 text-uppercase" style={{marginTop: '30px'}}>Ajouter une note</h2>
              <MDBCardBody className="mx-auto w-100 addInfo-padding">


                <div style={{marginTop: '28px'}}>
                  <input
                    className="form-control"
                    type="date"
                    name="selectedDate"
                    defaultValue={props.form.selectedDate}
                    onChange={props.handleChangeValue}
                    style={{
                      fontSize: '18px',
                      color: 'black',
                      fontWeight: '450',
                    }} />
                </div>
                <div style={{marginTop: '22px'}}>
                  <MDBCheckbox name='extra1' id='inlineCheckbox11111' label='Extra possible' onChange={props.handleChangeCheckbox} inline />
                  {localStorage.getItem('admin') === '1' ?
                  <React.Fragment>
                    <MDBCheckbox name='extra2' id='inlineCheckbox22222' label='Extra valider' onChange={props.handleChangeCheckbox} inline />
                    <MDBCheckbox name='extra3' id='inlineCheckbox33333' label='Extra confirmer' onChange={props.handleChangeCheckbox} inline />
                  </React.Fragment> : '' }
                </div>

                <div className="form-group">
                  <textarea
                    type="text"
                    name="note"
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Note" />
                </div>
                {props.errors && props.errors.note && (
                  <span className="error">{props.errors.note}</span>
                )}
                <Button
                  color="white"
                  size="lg"
                  style={{
                    color: 'white',
                    fontSize: 'calc(10px + 2vmin)',
                    backgroundColor: '#363E46',
                    border: 'none',
                    width: '100%',
                    marginTop: '15px',
                  }}
                  onClick={props.handleSubmit}>
                  Enregistrer
                </Button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default AddNoteView;
